var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c("div", { staticClass: "contents_wrap" }, [
      _c("h2", { staticClass: "pg_title" }, [_vm._v("Other Request")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "sub_tit" }, [_vm._v("Basic")]),
      _vm._v(" "),
      _c("table", { staticClass: "create_table" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _vm._m(2),
            _vm._v(" "),
            _c("td", [
              _c("span", { staticClass: "clearable" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.name,
                      expression: "name"
                    },
                    { name: "validation", rawName: "v-validation" },
                    { name: "clearable", rawName: "v-clearable" }
                  ],
                  staticClass: "text_input w100",
                  attrs: { type: "text", placeholder: "", maxlength: "30" },
                  domProps: { value: _vm.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.name = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c("td", [
              _c("span", { staticClass: "clearable" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.engName,
                      expression: "engName"
                    },
                    { name: "validation", rawName: "v-validation" },
                    { name: "clearable", rawName: "v-clearable" }
                  ],
                  staticClass: "text_input w100",
                  attrs: { type: "text", placeholder: "", maxlength: "30" },
                  domProps: { value: _vm.engName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.engName = $event.target.value
                    }
                  }
                })
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn_wrap_full topLine" }),
      _vm._v(" "),
      _c("div", { staticClass: "sub_tit mt40" }, [
        _vm._v("Request Information")
      ]),
      _vm._v(" "),
      _c("table", { staticClass: "create_table" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _vm._m(5),
            _vm._v(" "),
            _c("td", [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedRequestType,
                      expression: "selectedRequestType"
                    }
                  ],
                  staticClass: "slt_white w100",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedRequestType = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                _vm._l(_vm.availableRequestTypeList, function(item) {
                  return _c(
                    "option",
                    { key: item.CODE_ID, domProps: { value: item.CODE_ID } },
                    [_vm._v(_vm._s(item.CODE_NAME))]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("td")
          ]),
          _vm._v(" "),
          _vm.isImeiPwdVisible
            ? _c("tr", [
                _vm._m(6),
                _vm._v(" "),
                _c("td", [
                  _c("span", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.imeiPwd,
                          expression: "imeiPwd"
                        },
                        { name: "validation", rawName: "v-validation" },
                        { name: "clearable", rawName: "v-clearable" }
                      ],
                      staticClass: "text_input w100",
                      attrs: {
                        type: "password",
                        minlength: "10",
                        maxlength: "20",
                        placeholder: ""
                      },
                      domProps: { value: _vm.imeiPwd },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.imeiPwd = $event.target.value
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:" },
                      on: { click: _vm.showPasswordRules }
                    },
                    [
                      _c("span", { staticClass: "ico_sech_sm" }, [
                        _vm._v("search아이콘")
                      ]),
                      _vm._v(
                        "\n                            View Password Rules\n                        "
                      )
                    ]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isImeiPwdVisible
            ? _c("tr", [
                _vm._m(7),
                _vm._v(" "),
                _c("td", [
                  _c("span", { staticClass: "clearable" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.imeiPwdConfirm,
                          expression: "imeiPwdConfirm"
                        },
                        { name: "validation", rawName: "v-validation" },
                        { name: "clearable", rawName: "v-clearable" }
                      ],
                      staticClass: "text_input w100",
                      attrs: {
                        type: "password",
                        minlength: "10",
                        maxlength: "20",
                        placeholder: ""
                      },
                      domProps: { value: _vm.imeiPwdConfirm },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.imeiPwdConfirm = $event.target.value
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("td")
              ])
            : _vm._e(),
          _vm._v(" "),
          ["006", "007"].includes(_vm.selectedRequestType)
            ? _c("tr", [
                _c("th", [_vm._v("Country")]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedCountry,
                          expression: "selectedCountry"
                        },
                        { name: "validation", rawName: "v-validation" }
                      ],
                      staticClass: "slt_white w100",
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedCountry = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.onCountryChange
                        ]
                      }
                    },
                    _vm._l(_vm.availableCountryList, function(item) {
                      return _c(
                        "option",
                        {
                          key: item.CODE_ID,
                          domProps: { value: item.CODE_ID }
                        },
                        [_vm._v(_vm._s(item.CODE_NAME))]
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("td")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedRequestType === "008"
            ? _c("tr", [
                _c("th", [_vm._v("User Role")]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedUserRole,
                          expression: "selectedUserRole"
                        }
                      ],
                      staticClass: "slt_white w100",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedUserRole = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.availableUserRoleList, function(item) {
                      return _c(
                        "option",
                        {
                          key: item.CODE_ID,
                          domProps: { value: item.CODE_ID }
                        },
                        [_vm._v(_vm._s(item.CODE_NAME))]
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("td")
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn_wrap_full topLine" }, [
        _c("div", { staticClass: "btn_right" }, [
          _c(
            "a",
            {
              staticClass: "btn_blue",
              attrs: { title: "" },
              on: { click: _vm.onRequestBtnClick }
            },
            [_vm._v("Request")]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bc_ico" }, [
      _vm._v("\n            Home\n            "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v("Engineer\n            "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v(" Mobile SVC\n            "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v("Other Request\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "16%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "18%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("\n                        Name\n                        "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v(
        "\n                        English Name\n                        "
      ),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "16%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "40%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("Request Type\n                    "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("ESN/IMEI Writing P/W\n                        "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("ESN/IMEI Confirm P/W\n                        "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bdae60e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bdae60e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/anysvcmobile/request/RequestOther.vue
// module id = n8sw
// module chunks = 0